import script from "./ShowDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowDetails.vue?vue&type=script&setup=true&lang=js"

import "./ShowDetails.vue?vue&type=style&index=0&id=0b00401c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b00401c"]])

export default __exports__